import { InternalUserStore } from 'store/internalUser/types.ts'

export const initialInternalUserState: InternalUserStore = {
  internalUsers: [],
  loading: false
}
